import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IGroup } from '@obvious.tech/constellation'

export const Group = defineEntity('Group', {
  endpoint: 'authentication/api/Group',
  schema: SNoop<IGroup>(),
})
